import { render, staticRenderFns } from "./Caracteristicas.vue?vue&type=template&id=9b43deb8"
import script from "./Caracteristicas.vue?vue&type=script&lang=js"
export * from "./Caracteristicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports